import Vue from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faLock,
    faBars,
    faArrowsRotate,
    faTable,
    faAdd,
    faArrowLeft,
    faEye,
    faTrash,
    faEdit,
    faEyeSlash,
    faLocation,
    faKey,
    faUsers,
    faGear,
    faTag,
    faLocationDot
} from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
    faHome, faLock,faBars,faArrowsRotate,faTable,faAdd,faArrowLeft,faEye,faTrash,faEdit,faEyeSlash,faLocation,faKey,faUsers,faGear,faTag,faLocationDot
)

